export default __webpack_public_path__ + "static/project-slide-8-1248-765-b18369acc866d8cf10bc111a5f65d095.webp";